import React, { FunctionComponent } from 'react';
import { useParams } from 'react-router';
import { EditService, NewService } from './containers';
import { ServiceProvider } from './context';
import { useMixpanelTrackPage } from '@/analytics/hooks';
import useScreenSize from '@/hooks/useScreenSize';
import { useIntercom } from '@/hooks/useIntercom';

export const ActionServiceV2: FunctionComponent = () => {
  const { id } = useParams();
  const { isMobile } = useScreenSize();
  useIntercom(!isMobile);
  const isEdit = !!id;

  useMixpanelTrackPage('Action Service', {
    mode: isEdit ? 'Edit' : 'Create',
    subscription_id: id
  });

  return <ServiceProvider serviceId={id}>{isEdit ? <EditService /> : <NewService />}</ServiceProvider>;
};
